import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { Calendar, MapPin, Clock, Ticket } from 'lucide-react';

const EventsPage = () => {
  const socialLinks = {
    instagram: 'https://www.instagram.com/bondboxing?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==',
    facebook: 'https://www.facebook.com/BondBoxingpromotions'
  };

  const upcomingEvents = [
    {
      title: 'Bond Boxing Fight Night Championship',
      date: 'August 8, 2026',
      venue: 'Fairground Holdings, Gaborone',
      time: '7:00 PM',
      mainEvent: 'Tshephang Gomotho vs George Molwantwa',
      subtitle: 'National Super Bantamweight Title Fight',
      status: 'Tickets Available',
      ticketLink: 'https://www.webtickets.co.bw/v2/event.aspx?itemid=6204409',
      poster: 'https://i.imgur.com/zu3AGAi.jpeg',
      bouts: [
        {
          title: 'Tshephang Gomotho vs George Molwantwa',
          weight: 'Super Bantamweight',
          type: 'MAIN EVENT'
        },
        {
          title: 'Modise Ribbin vs Kerapetse Sekgole',
          weight: 'Bantamweight',
          type: 'CO-MAIN EVENT'
        },
        {
          title: 'Karbo Motshwarakgole vs Nonofo Molathegi ',
          weight: 'JR Walterweight',
          type: 'UNDERCARD'
        },
        {
          title: 'Monty Cheipe vs Onkarabille Modise',
          weight: 'Light Heavyweight',
          type: 'UNDERCARD'
        }
      ]
    },
    {
      title: 'Natonal Bantamweight Contest',
      date: 'August 8, 2026',
      venue: 'Fairground Holdings, Gaborone',
      time: '7:00 PM',
      status: 'Tickets Available',
      ticketLink: 'https://example.com/buy-tickets',
      poster: 'https://i.imgur.com/VZ3tnfZ.jpeg',
      bouts: []
    },
    {
      title: 'National JR Walterweight Contest',
      date: 'August 8, 2026',
      venue: 'Fairground Holdings, Gaborone',
      time: '7:00 PM',
      status: '',
      ticketLink: 'https://example.com/buy-tickets',
      poster: 'https://i.imgur.com/0ZSZ2Ss.jpeg',
      bouts: []
    },
    {
      title: 'National light Heavyweight Contest',
      date: 'August 8, 2026',
      venue: 'Fairground Holdings, Gaborone',
      time: '7:00 PM',
      subtitle: 'Undercard Highlights',
      status: '',
      ticketLink: 'https://example.com/buy-tickets',
      poster: 'https://i.imgur.com/CX3CZFX.jpeg',
      bouts: []
    }
  ];

  const showUpcomingEvents = false;

  const pastEvents = [
    {
      title: 'Boxing Fight Night Championship - Fourth Edition.',
      date: 'August 9, 2025',
      result: '6 Exciting Bouts - Sold Out Event',
      image: 'https://i.imgur.com/WeCAI0L.jpeg'
    },
    {
      title: 'Boxing Fight Night Championship - Fifth Edition',
      date: 'November 8, 2025',
      result: 'Championship Victory',
      image: 'https://i.imgur.com/W2nNb4D.jpeg'
    },
    {
      title: 'Boxing Fight Night Championship - Third Edition',
      date: 'October 4, 2024',
      result: '10 Amateur Bouts',
      image: 'https://i.imgur.com/oAWSMzn.jpeg'
    }
  ];

  const partners = [
    {
      name: 'Broadhurst Tyre',
      src: '/partners/broadhurst-tyre.jpeg',
      logoClass: 'w-full max-w-[260px] md:max-w-[300px]'
    },
    {
      name: 'Rammika Tafa & Jallow Attorneys at Law',
      src: '/partners/tafa-jallow.png',
      logoClass: 'w-full max-w-[280px] md:max-w-[320px]'
    },
    {
      name: 'About Physiotherapy Clinic',
      src: '/partners/about-physiotherapy-clinic.png',
      logoClass: 'w-full max-w-[300px] md:max-w-[340px]'
    }
  ];

  const eventHighlightImages = [
    'https://i.imgur.com/UAFPVfF.jpeg',
    'https://i.imgur.com/HDKIt9Z.jpeg',
    'https://i.imgur.com/o5iZKyq.jpeg',
    'https://i.imgur.com/XN3UX8n.jpeg',
    'https://i.imgur.com/NY5mpAH.png',
    'https://i.imgur.com/W2nNb4D.jpeg',
    'https://i.imgur.com/ot7UOgd.jpeg',
    'https://i.imgur.com/WeCAI0L.jpeg',
    'https://i.imgur.com/BVNeiyi.jpeg',
    'https://i.imgur.com/Q9MNKRv.jpeg',
    'https://i.imgur.com/dZgthfL.jpeg',
    'https://i.imgur.com/vCterBy.jpeg',
    'https://i.imgur.com/i1UEp8e.jpeg',
    'https://i.imgur.com/a7Rc4XD.jpeg',
    'https://i.imgur.com/gHL6nsM.jpeg',
    'https://i.imgur.com/wFluoem.jpeg',
    'https://i.imgur.com/XUBgydj.jpeg',
    'https://i.imgur.com/fRdYmP8.jpeg',
    'https://i.imgur.com/phPKYgo.jpeg',
    'https://i.imgur.com/lbrr6mR.png',
    'https://i.imgur.com/gS6zIaP.jpeg'
  ];

  return (
    <div className="min-h-screen bg-black">

      <SEO
        title="Boxing Events in Gaborone | Bond Boxing Promotions"
        description="Discover Bond Boxing Promotions in Gaborone, Botswana. Explore professional boxing fight nights, championship contests, amateur tournaments and highlights from previous boxing events."
        path="/events"
      />

      <Navigation />

      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://i.imgur.com/tTDfABV.jpeg"
            alt="Bond Boxing fight night event in Gaborone"
            fetchPriority="high"
            decoding="async"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 tracking-wider">
            Events
          </h1>

          <p className="text-red-500 text-2xl md:text-3xl font-semibold mb-6 italic">
            "This Is Boxing"
          </p>

          <p className="text-gray-300 text-lg md:text-xl max-w-2xl mx-auto">
            Bringing world-class boxing events to Gaborone. Experience the thrill of professional boxing and witness future champions in action.
          </p>
        </div>
      </section>

      {/* Featured Upcoming Event */}
      {showUpcomingEvents && upcomingEvents.length > 0 && (
        <section className="bg-black py-16 md:py-24">
          <div className="container mx-auto px-6">
            <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center max-w-6xl mx-auto">

              <div className="flex justify-center md:justify-end">
                <div className="relative group" style={{ maxWidth: '762px', width: '100%' }}>
                  <div
                    className="rounded-lg overflow-hidden shadow-2xl group-hover:shadow-red-600/50 transition-all duration-500"
                    style={{ aspectRatio: '762/925', width: '100%' }}
                  >
                    <img
                      src={upcomingEvents[0].poster}
                      alt={upcomingEvents[0].title}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <div className="absolute top-4 left-4 md:top-6 md:left-6">
                    <span className="bg-red-600 text-white px-4 py-2 text-sm md:text-base font-bold rounded">
                      {upcomingEvents[0].status}
                    </span>
                  </div>
                </div>
              </div>

              <div className="md:pl-6">
                <h2 className="text-4xl md:text-5xl font-bold text-white mb-2">
                  {upcomingEvents[0].title}
                </h2>

                <p className="text-red-500 text-xl md:text-2xl font-semibold mb-8 italic">
                  {upcomingEvents[0].subtitle}
                </p>

                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-4">
                    <Calendar className="text-red-500 flex-shrink-0 mt-1" size={24} />
                    <div>
                      <div className="text-gray-400 text-sm">DATE</div>
                      <div className="text-white text-lg font-semibold">{upcomingEvents[0].date}</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <Clock className="text-red-500 flex-shrink-0 mt-1" size={24} />
                    <div>
                      <div className="text-gray-400 text-sm">TIME</div>
                      <div className="text-white text-lg font-semibold">{upcomingEvents[0].time}</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <MapPin className="text-red-500 flex-shrink-0 mt-1" size={24} />
                    <div>
                      <div className="text-gray-400 text-sm">VENUE</div>
                      <div className="text-white text-lg font-semibold">{upcomingEvents[0].venue}</div>
                    </div>
                  </div>
                </div>

                <div className="border-t border-gray-700 pt-6 mb-8">
                  <div className="text-red-500 text-sm font-semibold mb-4">FIGHT CARD</div>

                  <div className="space-y-4">
                    {upcomingEvents[0].bouts.map((bout, index) => (
                      <div key={index} className="pb-3 border-b border-gray-700 last:border-b-0">
                        <div className="text-red-500 text-xs font-bold mb-1">{bout.type}</div>
                        <div className="text-white font-semibold">{bout.title}</div>
                        <div className="text-gray-400 text-sm">{bout.weight}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <a
                  href={upcomingEvents[0].ticketLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full md:w-auto inline-flex bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold text-lg transition-all duration-300 items-center justify-center gap-2 rounded-lg group"
                >
                  <Ticket size={24} />
                  <span>Get Tickets Now</span>
                </a>
              </div>

            </div>
          </div>
        </section>
      )}

      {/* About Events */}
      <section className="bg-zinc-950 py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-white text-4xl md:text-5xl font-bold mb-6">
              Built For Champions
            </h2>

            <p className="text-gray-400 text-lg leading-relaxed mb-6">
              Bond Boxing Promotions is dedicated to showcasing the best boxing talent in Botswana and beyond. We organize professional fight nights, amateur tournaments, and championship events that bring together fighters, fans, and the community.
            </p>

            <p className="text-gray-400 text-lg leading-relaxed">
              From up-and-coming amateurs to seasoned professionals, our events provide a platform for boxers to demonstrate their skills, compete at the highest level, and entertain audiences with world-class boxing action.
            </p>
          </div>
        </div>
      </section>

      {/* Upcoming Events */}
      {showUpcomingEvents && upcomingEvents.length > 0 && (
        <section className="bg-black py-20">
          <div className="container mx-auto px-6 max-w-7xl">
            <div className="text-center mb-16">
              <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
                Upcoming Fight Nights
              </h2>

              <p className="text-gray-400 text-lg">
                Don't miss these exciting upcoming events
              </p>
            </div>

            <div>
              <h3 className="text-white text-2xl font-bold mb-8">
                Upcoming Bouts
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {upcomingEvents.map((event, index) => (
                  <div
                    key={index}
                    className="bg-zinc-950 border border-gray-800 hover:border-red-600 transition-all duration-300 overflow-hidden group rounded-lg flex flex-col"
                  >
                    <div className="w-full" style={{ aspectRatio: '3/4', minHeight: 0 }}>
                      <div className="w-full h-full bg-black flex items-center justify-center">
                        <img
                          src={event.poster}
                          alt={`${event.title} boxing event poster`}
                          loading="lazy"
                          decoding="async"
                          className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                        />

                        {event.status && (
                          <div className="absolute top-3 left-3">
                            <span className="bg-red-600 text-white px-3 py-1 text-xs font-bold rounded">
                              {event.status}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="p-4 flex-1 flex flex-col justify-between">
                      <div>
                        <h4 className="text-white text-lg font-bold mb-2 line-clamp-2">
                          {event.title}
                        </h4>

                        <div className="text-gray-400 text-sm mb-3">
                          <div className="flex items-center gap-2">
                            <Calendar className="text-red-500" size={16} />
                            <span>{event.date}</span>
                          </div>

                          <div className="flex items-center gap-2">
                            <Clock className="text-red-500" size={16} />
                            <span>{event.time}</span>
                          </div>

                          <div className="flex items-center gap-2">
                            <MapPin className="text-red-500" size={16} />
                            <span className="line-clamp-1">{event.venue}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Past Events */}
      <section className="bg-zinc-950 py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              Past Fight Nights
            </h2>

            <p className="text-gray-400 text-lg">
              Highlights from our previous fight nights
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {pastEvents.map((event, index) => (
              <div
                key={index}
                className="bg-black border border-gray-800 hover:border-red-600 transition-all duration-300 overflow-hidden group"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={event.image}
                    alt={`${event.title} in Gaborone`}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent"></div>
                </div>

                <div className="p-6">
                  <h3 className="text-white text-xl font-bold mb-2">
                    {event.title}
                  </h3>

                  <div className="text-gray-400 mb-3">{event.date}</div>
                  <div className="text-red-500 font-semibold">{event.result}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Event Highlights Gallery */}
      <section className="bg-black py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              Event Highlights
            </h2>

            <p className="text-gray-400 text-lg">
              Memorable moments from Bond Boxing events
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-4">
            {eventHighlightImages.map((img, index) => (
              <div key={index} className="relative h-64 overflow-hidden group cursor-pointer">
                <img
                  src={img}
                  alt={`Boxing event highlight ${index + 1} from Bond Boxing`}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />

                <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Tournament Announcements */}
      <section className="bg-zinc-950 py-20">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              Stay Updated
            </h2>

            <p className="text-gray-400 text-lg mb-10">
              Follow us on social media for the latest tournament announcements, fighter updates, and event news.
            </p>

            <div className="flex flex-wrap justify-center gap-4">
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noreferrer"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-semibold transition-all duration-300 inline-block"
              >
                Follow on Instagram
              </a>

              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noreferrer"
                className="border-2 border-red-600 text-red-600 hover:bg-red-600 hover:text-white px-8 py-4 font-semibold transition-all duration-300 inline-block"
              >
                Follow on Facebook
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="bg-black py-20">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-white text-5xl md:text-6xl font-bold mb-6">
              Partners
            </h2>

            <p className="text-gray-400 text-lg max-w-2xl mx-auto">
              Proudly supporting Bond Boxing events and fight-night experiences.
            </p>
          </div>

          <div className="max-w-6xl mx-auto bg-white px-8 py-10 md:px-10 md:py-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 items-center justify-items-center">
              {partners.map((partner) => (
                <div
                  key={partner.name}
                  className="w-full flex items-center justify-center"
                >
                  <div className="w-full h-32 md:h-28 flex items-center justify-center overflow-hidden">
                    <img
                      src={partner.src}
                      alt={`${partner.name} - Bond Boxing partner`}
                      loading="lazy"
                      decoding="async"
                      className={`${partner.logoClass} max-h-full object-contain`}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EventsPage;